import { getVideoCarouselAssetsArray } from '../utils/client-requests';

/**
 * A function that will "clean" the single video data object, removing the unused keys making it more light
 * @param {object} data the data of a single video (title, thumb, creation date, section....)
 * @returns {object} with 3 keys, assetId, title and the url of the thumb
 */
const transformVideoCarouselData = (data) => {
  return {
    assetId: data.asset_id,
    channel: data.channel,
    subchannel: data.subchannel,
    sub_subchannel: data.sub_subchannel,
    title: data.title,
    title_norm: data.title_norm,
    thumb: data.thumb,
  };
};

/**
 * A function that get a list of video data and filters it
 * @param {object} tabData the object that contains the configurations for the videoportal BE calls
 * @param {string} baseUrl the base of the videoportal BE APIs
 * @returns {Array} A filtered array with the metadata needed to build the video carousel
 */
export const getCarouselArrayTransformed = (tabData, baseUrl, hlPrevTags) => {
  return getVideoCarouselAssetsArray(tabData, baseUrl, hlPrevTags)
    .then((data) => data.map(transformVideoCarouselData))
    .catch((error) => {
      throw error;
    });
};
